import { FormGroup } from '@angular/forms';

export class PasswordValidation {
  static validate(registrationFormGroup: FormGroup): any {
    const password = registrationFormGroup.controls.password.value;
    const repeatPassword = registrationFormGroup.controls.confirmPassword.value;

    if (!repeatPassword || repeatPassword.length <= 0) {
      return null;
    }

    if (repeatPassword !== password) {
      return registrationFormGroup.controls.confirmPassword.setErrors({
        doesNotMatchPassword: true
      });
    }

    return null;
  }
}
